import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import { SettingsProvider } from './contexts/SettingsContext'
import { CurrencyProvider } from './contexts/CurrencyContext'
import { AuthProvider } from './contexts/AuthContext'
import { PageActionProvider } from './contexts/PageActionContext'
import App from './App.jsx'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <AuthProvider>
        <SettingsProvider>
          <CurrencyProvider>
            <PageActionProvider>
              <App />
              <Toaster
                position="bottom-left"
                containerStyle={{
                  bottom: 24,
                  left: 24,
                  zIndex: 99999,
                }}
                toastOptions={{
                  duration: 4000,
                  style: {
                    background: '#1e293b',
                    color: '#f8fafc',
                    borderRadius: '10px',
                    boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.2), 0 8px 10px -6px rgba(0, 0, 0, 0.2)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    fontSize: '13.5px',
                    fontWeight: '500',
                  },
                  success: { duration: 3000, iconTheme: { primary: '#22c55e', secondary: '#fff' } },
                  error: { duration: 5000, iconTheme: { primary: '#ef4444', secondary: '#fff' } },
                }}
              />
            </PageActionProvider>
          </CurrencyProvider>
        </SettingsProvider>
      </AuthProvider>
    </BrowserRouter>
  </QueryClientProvider>
)